const Regexps = {
    FLOAT: /^\d+[,\.]?(\d*)?$/,
};

export default Regexps;



// WEBPACK FOOTER //
// ./client/constants/Regexps.js